module.exports = __webpack_public_path__ + "img/ThatsLife.944442ce.svg";